import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import SvgIcon from '../svg-icon/svg-icon';
import { Empty } from '../../helpers/icon-dictionary';
import css from './index.scss';
import messages from './messages';

const EmptyState = ({ message = '', iconName = '', intl }) => {
    const messageToRender = message === '' ? intl.formatMessage(messages.noResultFound) : message;
    const iconToShow = iconName === '' ? Empty : iconName;

    return (
        <div className={css.emptyContainer}>
            <div className={css.emptyNotice}>
                <div className={css.emptyState}>
                    <div className={css.emptyIconContainer}><SvgIcon icon={iconToShow} /></div>
                </div>
                <div className={css.noResult}>{messageToRender}</div>
            </div>
        </div>
    );
};

EmptyState.propTypes = {
    iconName: PropTypes.string,
    message: PropTypes.string,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(EmptyState));



// WEBPACK FOOTER //
// ./app/components/empty-state/index.js